import { countryName } from 'common/helpers/addresses';
import { phoneFormat } from 'common/helpers/phoneHelper';

const Address = (props) => {
  const { address, boldName } = props;
  return (
    <>
      {renderName(address, boldName)}
      <br />
      {countryName(address.countryCode)}
      <br />
      {renderPhoneNumber(address)}
    </>
  );
};

export default Address;

const renderName = (address, boldName) => {
  if (boldName) {
    return (
      <strong>
        {address.isDefault && '*'}
        {address.firstName} {address.lastName}
      </strong>
    );
  }
  return (
    <>
      {address.isDefault && '*'}
      {address.firstName} {address.lastName}
    </>
  );
};

const renderPhoneNumber = (address) => {
  if (address.phone) {
    return <>Phone: {phoneFormat(address.phone, address.countryCode)}</>;
  }
  return null;
};
